<template>
    <div class="journey-card">

        <div class="image" :style="{backgroundImage: `url(${previewUrlWidth(size)})`}">
            <i v-if="!preview_url" class="cvico-picture-o"></i>
        </div>

        <div class="options" v-if="editable">
            <button class="btn"></button>
            <div class="lines">
                <ul class="sizes">
                    <li @click="resize(1)" :class="{active: width === 1}">1/3</li>
                    <li @click="resize(2)" :class="{active: width === 2}">2/3</li>
                    <li @click="resize(3)" :class="{active: width === 3}">Full</li>
                </ul>
                <div class="sep"></div>
                <a class="delete" href="#" @click.prevent="removeUpload">Delete</a>
            </div>
        </div>

        <div class="info">
            <div class="title" :title="title">{{ title }}</div>
<!--            <div class="desc">DESCRIPTION/DATE</div>-->
        </div>
    </div>
</template>

<script>
import uploads from "@/mixins/uploads";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "JourneyCard",
    components: {},
    mixins: [uploads],
    props: {
        upload: {
            type: Object,
        },
        preview: {
            type: [Object, Boolean],
            default: () => ({w: 480, h: 480, c: true}),
        },
        editable: {
            type: Boolean,
            default: false,
        },
    },


    computed: {

        file(){
            return this.upload?.file ?? null;
        },

        title(){
            return this.file?.name?.replace('%20', ' ');
        },

        options: {
            get(){
                return this.upload?.options ?? {};
            },
            set(value){
                return this.upload.options = value;
            }
        },

        width(){
            return this.options.width ?? 1;
        },

        preview_options(){
            if( this.preview === true ){
                return {w: 240, h: 240, c: true}
            }
            return this.preview;
        },

        is_video() {
            switch (this.file?.mime){
                case 'video/mp4':
                case 'video/avi':
                case 'video/mov':
                    return true;
            }
            return false;
        },

        preview_url(){
            switch (this.file?.mime){
                case 'image/jpeg':
                case 'image/jpg':
                case 'image/png':
                case 'image/gif':
                case 'application/pdf':
                    return this.file?.preview_url ? this.file.preview_url : this.file?.url;

                default:
                    return this.file?.preview_url ? this.file.preview_url : null;
            }
        },

        // preview_url_thumb(){
        //     if( this.preview ){
        //         return this.uploads.image( this.preview_url, this.preview_options );
        //     }
        //     return this.preview_url;
        // },
        //
        // preview_url_large(){
        //     return this.uploads.image( this.preview_url, {w: 1200, h: 1200, c: false});
        // },
    },

    methods: {

        ...mapActions('canvas2', ['setActivityUploadOptions', 'removeActivityUploadOnCanvas']),

        previewUrlWidth(width = null){
            switch (width){
                case 1:
                    return this.uploads.image( this.preview_url, {w: 420, h: 420, c: false});

                case 2:
                    return this.uploads.image( this.preview_url, {w: 1024, h: 1024, c: false});

                case 3:
                    return this.uploads.image( this.preview_url, {w: 1400, h: 1400, c: false});

                default:
                    return this.uploads.image( this.preview_url, {w: 1200, h: 1200, c: false});
            }
        },

        async resize(width){
            await this.setActivityUploadOptions({
                upload_id: this.upload.id,
                options: {width},
            });
        },

        async removeUpload(){
            if( !confirm('Are you sure to remove this item?') ) return;
            await this.removeActivityUploadOnCanvas(this.upload.id);
        }

    }

}
</script>

<style lang="scss" scoped>
.journey-card{
    background: white;
    border-radius: .3rem;
    box-shadow: rgba(black, 0.1) 0 0 15px;
    position: relative;
}
.image{
    height: 50vh;
    border-radius: .3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent no-repeat center / cover;

    @media (max-width: 991px) {
        height: 380px;
        @media (max-width: 650px) {
            height: auto;
            aspect-ratio: 1;
        }
    }
    i {
        position: relative;
        top: -3rem;
        font-size: 3rem;
        color: darken($light, 10%);
    }
}

.info{
    position: absolute;
    left: 1rem;
    right: 1rem;
    bottom: 1rem;
    background: rgba(white, 0.9);
    box-shadow: rgba(black, 0.15) 0 0 15px;
    border-radius: .3rem;
    padding: 1rem;
    text-align: center;
    backdrop-filter: blur(3px);
}

.title{
    font-size: 1.56rem;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: 650px) {
        font-size: 1rem;
        @media (max-width: 400px) {
            font-size: 0.8rem;
        }
    }
}

.desc{
    font-size: 1rem;
    color: #77838F;
}

.options{
    position: absolute;
    top: 0;
    right: 0;

    &:hover{
        .btn{
            background: white;
        }

        .lines{
            display: block;
        }
    }

    .btn{
        height: 36px;
        width: 38px;
        border-radius: .3rem .3rem 0 0;

        &:before{
            position: absolute;
            top: 8px;
            left: 50%;
            transform: translate(-50%, 0);
            content: '';
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: white;
            box-shadow: black 0 0 2px, white 0 8px 0, white 0 16px 0, black 0 8px 2px, black 0 16px 2px;
        }
    }

    .lines{
        position: absolute;
        top: 100%;
        right: 0;
        display: none;
        box-shadow: rgba(black, .1) 0 2px 3px;
    }

    .sizes{
        list-style: none;
        padding: 0;
        margin: 0;
        width: 100%;
        display: flex;

        li{
            padding: .6rem 1rem;
            cursor: pointer;
            background: white;
            flex-grow: 1;

            &.active{
                background: $success;
                color: white;
            }

            &:hover{
                background: darken(white, 10%);
                color: black;
            }

            &:first-child{
                border-top-left-radius: .3rem;
                //border-bottom-left-radius: .3rem;
            }

            &:last-child{
                //border-bottom-right-radius: .3rem;
            }

        }
    }


    .sep{
        position: relative;
        background: white;
        padding: 6px 0;

        &:after{
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border: rgba(lighten(black, 25%), .1) solid 1px;
        }
    }

    .delete{
        background: $danger;
        color: white;
        display: block;
        text-decoration: none;
        padding: .6rem .6rem;
        border-radius: 0 0 .3rem .3rem;

        &:hover{

        }
    }
}

</style>
